(function patchOptionSelectionProductUpdate() {
  var Shopify = window.Shopify;

  if (!Shopify || !Shopify.Product) {
    return;
  }

  Shopify.Product.prototype.update = function updateProduct(json) {
    Object.keys(json).forEach(function assignProductProperty(property) {
      this[property] = json[property];
    }, this);
  };
}());
